module.exports = __webpack_public_path__ + "static/media/logo2.4e957be2.svg";